import {
	Content,
	JSONSelection,
	MenuButton,
	MenuItem,
	RenderValueProps,
	renderJSONSchemaEnum,
	renderValue,
	createJSONEditor
} from 'vanilla-jsoneditor';
import {
	Input,
	Output,
	EventEmitter,
	Component,
	ViewChild,
	ElementRef,
	ViewEncapsulation,
	OnInit,
	AfterViewInit
} from '@angular/core';

@Component({
	selector: 'nx-ahs-vanilla-json-editor',
	templateUrl: './vanilla-json-editor.component.html',
	styleUrl: './vanilla-json-editor.component.css',
	// IMPORTANT: ViewEncapsulation.None is required for Portal (but not HealthTrack) because:
	// 1. Portal uses Ionic framework which has global CSS that overrides component styles
	// 2. vanilla-jsoneditor dynamically generates CodeMirror DOM elements after Angular initialization
	// 3. Without None, Angular scopes the CSS and it won't apply to CodeMirror's dynamic elements
	// 4. The 600+ lines of CodeMirror CSS in this component file need to reach those elements
	// 5. Portal's global.scss has .ahs-form-scripting { color: #3d3d3d !important } which would
	//    override syntax highlighting if not blocked at the editor container level
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class VanillaJsonEditorComponent implements OnInit, AfterViewInit {
	@ViewChild('jsonEditor', { static: false })
	jsonEditorEl!: ElementRef;

	@Input()
	content: Content;

	@Input()
	subtractHeight: number = 170;

	@Input()
	mode: 'tree' | 'text' | 'table' = 'text';

	@Output()
	jsonChanged = new EventEmitter<any>(null);

	@Output()
	jsonValidityChanged = new EventEmitter<boolean>();

	@Output()
	onSelect = new EventEmitter<any>(null);

	public editor: any;
	public isText: boolean = true;
	public newHeight: string;

	ngOnInit() {
		this.newHeight = `calc(100vh - ${this.subtractHeight}px)`;
	}

	ngAfterViewInit() {
		let content = this.content;

		this.editor = createJSONEditor({
			target: this.jsonEditorEl.nativeElement,
			props: {
				content,
				onChange: (updatedContent, previousContent, { contentErrors, patchResult }) => {
					// content is an object { json: unknown } | { text: string }
					console.log('onChange', { updatedContent, previousContent, contentErrors, patchResult });

					content = updatedContent;

					let json = (updatedContent as any)?.json;
					if ((updatedContent as any)?.text && !json) {
						try {
							json = JSON.parse((updatedContent as any)?.text);
						} catch (e) {
							this.jsonValidityChanged.emit(false);
							return;
						}
					}
					this.jsonValidityChanged.emit(true);
					this.jsonChanged.emit(json);
				},
				onChangeMode: (mode: 'tree' | 'text') => {
					if (mode !== 'text') {
						this.isText = false;
					} else {
						this.isText = true;
					}
				},
				mode: this.mode,
				indentation: 4,
				onSelect: (selection) => {
					this.onSelect.emit(selection);
				}
			} as any
		});
	}
}
